import React, { useState } from "react";
import "../../styles/components/awardedQuotas.module.scss";

function getNumberLength(number) {
    return number === 0 ? 1 : Math.floor(Math.log10(Math.abs(number))) + 1;
}

function AwardedQuotas({awardedQuotas = [], maxVisible, ...props}) {
    const maxPrizeValue = awardedQuotas.reduce((acc, cur) => cur.value > acc ? cur.value : acc, 0);
    const higherQuotaNumber = awardedQuotas.reduce((acc, cur) => Number(cur.number) > acc ? Number(cur.number) : acc, 0);
    const higherQuotaNumberLength = getNumberLength(higherQuotaNumber);
    const [expand, setExpand] = useState(false);

    return awardedQuotas.length > 0
        ? <React.Fragment>
            <div className="awarded-quotas-card" {...props}>
                <h6>🏆 Cotas Premiadas</h6>
                <p className="subtitle">Ganhe prêmios de até <strong className="redText">R$ {maxPrizeValue}</strong> ao encontrar algumas dessas cotas!</p>

                <div className="awarded-quotas-grid">
                    {awardedQuotas
                        .filter((_, i) => expand ? true : i + 1 <= maxVisible)
                        .map((quota) => {
                            const quotaNumber = quota.number.padStart(higherQuotaNumberLength, "0");

                            return (<div className={`awarded-item ${quota.isAwarded && "unavailable"}`}>
                                <span className="awarded-number">🏆{quotaNumber}</span>
                            </div>)
                        })}
                </div>
                {awardedQuotas.length > maxVisible ? <p className="awarded-expand-toggler" onClick={() => setExpand(!expand)}>Ver {expand ? "menos" : "mais"}</p> : null}
            </div> 
        </React.Fragment>
        : null
};

export {AwardedQuotas}


// WEBPACK FOOTER //
// ./src/rifa/components/layout/awardedQuotas.jsx